import {
	FieldErrors,
	FieldValues,
	UseFormRegister,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';
import { InputEmail, InputPhone, InputText } from '@/components/form';

interface Props {
	setValue: UseFormSetValue<FieldValues>;
	errors: FieldErrors<FieldValues>;
	watch: UseFormWatch<FieldValues>;
	register: UseFormRegister<FieldValues>;
}

export const VenmoForm: React.FC<Props> = ({ setValue, register, errors }) => {
	const rules = {
		accountAlias: {
			required: { value: true, message: 'This field is required' },
			maxLength: {
				value: 35,
				message: 'Your first name has to have less than 35 characters',
			},
		},
	};
	return (
		<>
			<InputEmail
				title="Email"
				name="accountName"
				placeholder="Ex: norma.lauren@gmail.com"
				register={register}
				error={errors.accountName}
				setValueCustom={setValue}
			/>
			<InputText
				title="Alias"
				name="accountAlias"
				placeholder="Ex: Norma Lauren"
				register={register}
				rules={rules.accountAlias}
				error={errors.accountAlias}
			/>
			<InputPhone
				name="phoneNumber"
				title="Phone number"
				register={register}
				placeholder="Phone number"
				className="w-full"
				setValueInput={setValue}
				error={errors.phoneNumber}
			/>
		</>
	);
};
